var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"float-left mr-1"},[_c('span',{staticClass:"text-primary"},[_c('i',{staticClass:"fa fa-download fa-lg icon-button",attrs:{"title":"Download"},on:{"click":function($event){$event.stopPropagation();return _vm.downloadDocumento()}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }